import { render, staticRenderFns } from "./poList.vue?vue&type=template&id=b28a0008&"
import script from "./poList.vue?vue&type=script&lang=js&"
export * from "./poList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports